import * as React from 'react';
import { css } from '../../Utilities';
import * as stylesImport from './GroupSpacer.scss';
var styles = stylesImport;
var SPACER_WIDTH = 36;
export var GroupSpacer = function (props) {
    var count = props.count, _a = props.indentWidth, indentWidth = _a === void 0 ? SPACER_WIDTH : _a;
    return count > 0 ? (React.createElement("span", { className: css('ms-GroupSpacer', styles.root), style: { width: count * indentWidth } })) : null;
};
//# sourceMappingURL=GroupSpacer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/GroupedList/GroupSpacer.js
// module id = 46
// module chunks = 0